import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-status-page',
  imports: [HeaderLatestComponent, PeopleflowFooterComponent],
  templateUrl: './status-page.html',
  styleUrl: './status-page.scss',
})
export class StatusPage {

}
